import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ElementRef
} from '@angular/core';

import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { ProviderNotificationService } from '../../@core/services/provider-notification.service';
import { DataService } from '../../admin/data.service'; // ⚠️ adjust this path to wherever data.service.ts actually lives relative to this component

@Component({
  selector: 'ngx-provider-header-dropdown',
  templateUrl: './provider-header-dropdown.component.html',
  styleUrls: ['./provider-header-dropdown.component.scss']
})
export class ProviderHeaderDropdownComponent implements OnInit, OnDestroy {

  isOpen = false;

  orders: any[] = [];

  unreadCount = 0;

  private subs = new Subscription();


  constructor(
    private orderService: ProviderNotificationService,
    private router: Router,
    private elRef: ElementRef,
    private readonly dataService: DataService
  ) {}


  ngOnInit() {

    this.subs.add(
      this.orderService.orders$.subscribe((orders) => {

        console.log('📦 Provider orders updated in dropdown:', orders);

        this.orders = orders;

      })
    );


    this.subs.add(
      this.orderService.unreadCount$.subscribe((count) => {

        this.unreadCount = count;

      })
    );

  }


  ngOnDestroy() {

    this.subs.unsubscribe();

  }


  toggleDropdown(event: MouseEvent) {

    event.stopPropagation();

    this.isOpen = !this.isOpen;

  }


  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent) {

    if (!this.elRef.nativeElement.contains(event.target)) {

      this.isOpen = false;

    }

  }


  // openOrder(order: any, event: MouseEvent) {

  //   event.stopPropagation();

  //   this.orderService.markOrderSeen(order._id);

  //   this.isOpen = false;

  //   /*
  //    * ⚠️ CONFIRM — adjust this route to wherever the provider panel's
  //    * order-details page actually lives. Mirrored from the admin
  //    * dropdown's navigation to '/admin/grocery-orders/order-details'.
  //    */
  //   this.router.navigate(
  //     ['/provider/orders/requests', { id: order._id }]
  //   );

  //   this.dataService.setNewRowInfo(order);

  // }


  openOrder(order: any, event: MouseEvent) {

  event.stopPropagation();

  console.log('🔔 Clicked notification:', order);
  console.log('🆔 Order ID:', order?._id);

  if (!order?._id) {
    console.error('❌ Order ID is missing:', order);
    return;
  }

  this.orderService.markOrderSeen(order._id);

  this.isOpen = false;

  this.router.navigate([
    '/provider/orders/requests',
    order._id
  ]);

  this.dataService.setNewRowInfo(order);
}


  getTimeLabel(dateStr: string): string {

    if (!dateStr) {
      return '';
    }


    const d = new Date(dateStr);

    const diffMin = Math.floor(
      (Date.now() - d.getTime()) / 60000
    );


    if (diffMin < 1) {
      return 'just now';
    }


    if (diffMin < 60) {
      return `${diffMin}m ago`;
    }


    if (diffMin < 1440) {
      return `${Math.floor(diffMin / 60)}h ago`;
    }


    return d.toLocaleDateString(
      'en-GB',
      {
        day: '2-digit',
        month: 'short'
      }
    );

  }

}